const ViewButton = () => import('./ViewButton')
const View = () => import('./View')

export default function install(Vue) {
  Vue.component('cart-view-button', ViewButton)
  Vue.component('cart-view', View)
}
